export function readNativeInputReport(value, now = Date.now()) {
  const report = value?.integrationData?.remoteTarget?.inputInventory || value?.inputReport || value;
  if (report?.schemaVersion !== 1 || report.connector !== 'lg_webos_remote' || !Array.isArray(report.inputs)) return null;
  const stale = !Number.isFinite(Date.parse(report.collectedAt)) || now - Date.parse(report.collectedAt) > 5 * 60 * 1000;
  return { ...report, status: report.status === 'unavailable' ? 'unavailable' : stale ? 'stale' : report.status === 'partial' ? 'partial' : 'available' };
}

export function currentLgFieldSessionId(siteId) {
  try {
    const saved = JSON.parse(localStorage.getItem(`lgFieldSession:${siteId}`));
    return saved?.id && Date.now() - saved.startedAt < 86400000 ? saved.id : undefined;
  } catch (_) { return undefined; }
}
